module.exports = __webpack_public_path__ + "img/futsal.470b2a9c.svg";